import { MultiState } from './MultiState'
import { ThreeUpTag } from './ThreeUpTag'
import { Carousel } from './Carousel'
import { CollectionMarquee } from './CollectionMarquee'
import { FeatureBlock } from './FeatureBlock'
import { ScrollingCarousel } from './ScrollingCarousel'
import { Video } from './Video'
import { SectionHeader } from './SectionHeader'
import { TwoColImageText } from './TwoColImageText'
import { DonationCarousel } from './DonationCarousel'
import { DonationGrid } from './DonationGrid'
import { InfoGrid } from './InfoGrid'
import { CounterHero } from './CounterHero'
import { WorldBlock } from './WorldBlock'
import { SectionHeaderWithBody } from './SectionHeaderWithBody'
import { ContentBlock } from './ContentBlock'
import { PrinciplesGrid } from './PrinciplesGrid'
import { AnchorLinks } from './AnchorLinks'
import { WorldCarousel } from './WorldCarousel'

export const Modules = ({ modules }) => {
  if (!modules) return null
  return modules.map((module) => {
    if (typeof module.hidden !== 'undefined' && module.hidden) return null
    switch (module._type) {
      case 'multiState':
        return <MultiState key={module._key} {...module} />
      case 'threeUpTag':
        return <ThreeUpTag key={module._key} {...module} />
      case 'carousel':
        return <Carousel key={module._key} {...module} />
      case 'collectionMarquee':
        return <CollectionMarquee key={module._key} {...module} />
      case 'featureBlock':
        return <FeatureBlock key={module._key} {...module} />
      case 'scrollingCarousel':
        return <ScrollingCarousel key={module._key} {...module} />
      case 'video':
        return <Video key={module._key} {...module} />
      case 'sectionHeader':
        return <SectionHeader key={module._key} {...module} />
      case 'twoColImageText':
        return <TwoColImageText key={module._key} {...module} />
      case 'donationCarousel':
        return <DonationCarousel key={module._key} {...module} />
      case 'donationGrid':
        return <DonationGrid key={module._key} {...module} />
      case 'infoGrid':
        return <InfoGrid key={module._key} {...module} />
      case 'counterHero':
        return <CounterHero key={module._key} {...module} />
      case 'worldBlock':
        return <WorldBlock key={module._key} {...module} />
      case 'sectionHeaderWithBody':
        return <SectionHeaderWithBody key={module._key} {...module} />
      case 'contentBlock':
        return <ContentBlock key={module._key} {...module} />
      case 'principlesGrid':
        return <PrinciplesGrid key={module._key} {...module} />
      case 'anchorLinks':
        return <AnchorLinks key={module._key} {...module} />
      case 'worldCarousel':
        return <WorldCarousel key={module._key} {...module} />
      default:
        return null
    }
  })
}
